export default {
  common: {
    appName: 'Chaild Preschool',
    welcome: 'Chào mừng',
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    save: 'Lưu',
    cancel: 'Hủy',
    delete: 'Xóa',
    deleteConfirm: 'Xóa?',
    saved: 'Đã lưu',
    edit: 'Sửa',
    add: 'Thêm',
    search: 'Tìm kiếm',
    loading: 'Đang tải...',
    error: 'Lỗi',
    success: 'Thành công',
    confirm: 'Xác nhận',
    back: 'Quay lại',
    next: 'Tiếp theo',
    submit: 'Gửi',
    close: 'Đóng',
    yes: 'Có',
    no: 'Không',
    date: 'Ngày',
  },
  auth: {
    signIn: 'Đăng nhập',
    signOut: 'Đăng xuất',
    email: 'Email',
    password: 'Mật khẩu',
    forgotPassword: 'Quên mật khẩu?',
    rememberMe: 'Ghi nhớ đăng nhập',
    loginSuccess: 'Đăng nhập thành công',
    loginFailed: 'Đăng nhập thất bại',
    logoutSuccess: 'Đăng xuất thành công',
  },
  navigation: {
    home: 'Trang chủ',
    profile: 'Hồ sơ',
    settings: 'Cài đặt',
    notifications: 'Thông báo',
    toTodayRecord: 'Đến ghi chép hôm nay',
    toParentsRecord: 'Đến ghi chép gia đình',
  },
  settings: {
    title: 'Cài đặt',
    language: 'Ngôn ngữ',
    theme: 'Giao diện',
    notifications: 'Thông báo',
    privacy: 'Quyền riêng tư',
    about: 'Về chúng tôi',
    eventCalendar: 'Lịch sự kiện',
    switchNursery: 'Chuyển trường',
    notificationSettings: 'Cài đặt thông báo',
    logout: 'Đăng xuất',
  },
  errors: {
    notFound: 'Không tìm thấy trang',
    serverError: 'Lỗi máy chủ',
    networkError: 'Lỗi kết nối mạng',
    unauthorized: 'Truy cập không được phép',
    forbidden: 'Truy cập bị cấm',
    validationError: 'Dữ liệu không hợp lệ',
    E000: 'Hệ thống gặp lỗi không mong muốn. Vui lòng thử lại sau hoặc liên hệ hỗ trợ khách hàng.',
    E001: 'Tham số yêu cầu không khớp với thông số kỹ thuật API.',
    E002: 'Token đã hết hạn.',
    E003: 'Người dùng không tồn tại.',
    E004: 'Người dùng đã tồn tại.',
    E005: 'ObjectType được chỉ định không hợp lệ.',
    E006: 'Không có bản ghi bữa sáng.',
    E007: 'Bản ghi bữa sáng đã tồn tại.',
    E008: 'Không có bản ghi bữa tối.',
    E009: 'Bản ghi bữa tối đã tồn tại.',
    E010: 'Không có bản ghi đại tiện.',
    E011: 'Không có bản ghi sữa.',
    E012: 'Không có bản ghi ngủ.',
    E013: 'Không có bản ghi nhiệt độ.',
    E014: 'Không có bản ghi nhật ký chăm sóc.',
    E015: 'Bản ghi nhật ký chăm sóc đã tồn tại.',
    E016: 'Không có bản ghi bữa ăn.',
    E017: 'Bản ghi bữa ăn đã tồn tại.',
    E018: 'Không thể đăng ký do trùng lặp thời gian vắng mặt.',
    E019: 'Lý do được chọn không hợp lệ.',
    E020: 'Người đón được chọn không hợp lệ.',
    E021: 'Không tìm thấy tin nhắn.',
    E022: 'Không tìm thấy dữ liệu đón/trả.',
    E023: 'Không tìm thấy lớp.',
    E024: 'Không tìm thấy trẻ được chỉ định.',
    E025: 'Trẻ được chỉ định đã được đăng ký là thành viên gia đình của bạn.',
    E026: 'Không tìm thấy gia đình được chỉ định.',
    E027: 'Người dùng không thuộc gia đình được chỉ định.',
    E028: 'Người dùng được chỉ định đã được mời vào gia đình.',
    E029: 'Không tìm thấy định dạng được chỉ định.',
    E030: 'Chưa chỉ định ID trẻ.',
    E031: 'Thông tin feed được chỉ định không tồn tại.',
    E032: 'Thông tin chi tiết feed không tồn tại.',
    E033: 'Báo cáo được chỉ định không thuộc về người dùng.',
    E034: 'Bản ghi đi/về cho ngày được chỉ định đã tồn tại.',
    E035: 'Không có bản ghi đi/về.',
    E036: 'Không có bản ghi đi học cho ngày được chỉ định.',
    E037: 'Bản ghi đi học cho ngày được chỉ định đã tồn tại.',
    E038: 'Bản ghi về nhà cho ngày được chỉ định đã tồn tại.',
    E039: 'Bản ghi đi/về được chỉ định không thuộc về trẻ này.',
    E040: 'Trường mầm non không hợp lệ được chỉ định.',
    E041: 'Xác thực Hiragana thất bại. Vui lòng liên hệ hỗ trợ.',
    E042: 'ID sử dụng nội bộ không hợp lệ.',
    E043: 'UQID không hợp lệ.',
    E044: 'CheckSum không hợp lệ.',
    E045: 'Thực đơn được chỉ định không tồn tại.',
    E046: 'Chỉ người quản trị mới được phép thực hiện thao tác này.',
    E047: 'Lớp được chỉ định không thuộc về trường mầm non được chỉ định.',
    E048: 'Thực đơn có ngày và loại được chỉ định đã tồn tại.',
    E049: 'Thực đơn được chỉ định không thuộc về trường mầm non.',
    E050: 'Người dùng không thuộc về trường mầm non được chỉ định.',
    E051: 'Chỉ người quản trị mới được phép thực hiện thao tác này.',
    E052: 'Trạng thái phê duyệt nhật ký không hợp lệ.',
    E053: 'Không có bản ghi nhật ký trường mầm non.',
    E054: 'Người dùng này không có quyền phê duyệt.',
    E055: 'Người ghi nhật ký này không phải là người dùng này.',
    E056: 'Nhật ký này không ở trạng thái chờ phê duyệt.',
    E057: 'Người dùng khác có cùng quyền đã phê duyệt.',
    E058: 'Trạng thái ban đầu của nhật ký phải là đã đề nghị hoặc bản nháp.',
    E059: 'Không có bản ghi bản tin.',
    E060: 'Người dùng này không thuộc về trường mầm non của thực đơn.',
    E061: 'Bản ghi kiểm tra bữa ăn cho thực đơn đã tồn tại.',
    E062: 'Bản ghi kiểm tra bữa ăn được chỉ định không tồn tại.',
    E063: 'Sự kiện hàng năm được chỉ định không tồn tại.',
    E064: 'ID lớp được chỉ định không thuộc về trường mầm non.',
    E065: 'Định dạng socketId không hợp lệ. Vui lòng liên hệ quản trị viên hệ thống.',
    E066: 'Mẫu kiểm tra giấc ngủ không tồn tại.',
    E067: 'Nhân viên bị trùng lặp.',
    E068: 'Nhân viên được chỉ định không thuộc về trường mầm non.',
    E069: 'Mẫu kiểm tra giấc ngủ này không thuộc về trường mầm non này.',
    E070: 'Trẻ này không thuộc về trường mầm non này.',
  },
  messages: {
    confirmDelete: 'Bạn có chắc chắn muốn xóa?',
    saveSuccess: 'Lưu thành công',
    saveFailed: 'Lưu thất bại',
    deleteSuccess: 'Xóa thành công',
    deleteFailed: 'Xóa thất bại',
  },
  communication: {
    title: 'Liên lạc',
    chat: 'Trò chuyện',
    newMessage: 'Tin nhắn mới',
    newBroadcastMessage: 'Tin nhắn quảng bá mới',
    draft: 'Tin nháp',
    draftList: 'Danh sách tin nháp',
    readySendBox: 'Hộp thư đã gửi',
    readySendBoxTitle: 'Hộp thư chuẩn bị gửi',
    send: 'Gửi',
    sending: 'Đang gửi...',
    sent: 'Đã gửi',
    saveToDraft: 'Lưu vào tin nháp',
    saveToReadySend: 'Lưu vào hộp chuẩn bị gửi',
    savedToDraft: 'Đã lưu vào tin nháp',
    savedToReadySend: 'Đã lưu vào hộp chuẩn bị gửi',
    sentSuccess: 'Đã gửi thành công',
    confirm: 'Xác nhận',
    confirmed: 'Đã xác nhận',
    read: 'Đã đọc',
    viewOnly: '※Chỉ xem',
    contactEmail: '【Email liên lạc】',
    goToDraft: 'Đến tin nháp',
    goToReadySendBox: 'Đến hộp chuẩn bị gửi',
    openDraft: 'Mở tin nháp',
    openReadySendBox: 'Mở hộp chuẩn bị gửi',
    createBroadcastMessage: 'Tạo tin nhắn quảng bá',
    absenceConfirmDelete: 'Xác nhận/Xóa vắng mặt',
    deleteConfirm: 'Xóa?',
    deleted: 'Đã xóa',
    copyText: 'Sao chép văn bản',
    copied: 'Đã sao chép',
    copyFailed: 'Sao chép thất bại',
    showAttachment: 'Hiển thị tệp đính kèm',
    enterComment: 'Nhập bình luận',
    noClassAssigned: 'Chưa thiết lập lớp.',
    pdfFallback: 'Không thể hiển thị',
    downloadPdf: 'Tải PDF',
    // Các chức năng mới
    attendanceList: 'Danh sách điểm danh',
    noteList: 'Danh sách note',
    absenceList: 'Danh sách vắng mặt',
    chatList: 'Chat',
    hamburgerMenu: 'Menu hamburger',
    deleteAttendanceConfirm: 'Xóa xác nhận điểm danh',
    attendanceNote: 'Ghi chép điểm danh',
    draftsList: 'Danh sách bản nháp',
    readySendBoxList: 'Box chuẩn bị gửi',
    createBulkMessage: 'Tạo tin nhắn hàng loạt',
    individualMessages: 'Tin nhắn cá nhân',
    noSavedMessages: 'Không có tin nhắn đã lưu',
    
    // Attendance Summary
    currentChildrenCount: 'Số lượng trẻ hiện tại',
    absent: 'Nghỉ học',
    person: 'người',
    persons: 'người',
    inChargeClass: 'Lớp phụ trách',
  },
  
  // Diary
  diary: {
    draft: 'Bản nháp',
    applied: 'Đã đề nghị',
    approved: 'Đã phê duyệt',
    saveDraft: 'Lưu bản nháp',
    savedDraft: 'Đã lưu bản nháp',
    saveAndApply: 'Lưu & Đề nghị',
    reject: 'Từ chối',
    approve: 'Phê duyệt',
    confirmReject: 'Bạn có chắc chắn muốn từ chối?',
    willBeRejected: 'Sẽ được trả lại cho người đề nghị.',
    cancel: 'Hủy',
    chief: 'Trưởng phòng',
    director: 'Giám đốc',
    freeRecord: 'Ghi chép tự do',
    event: 'Sự kiện / Khách thăm',
    earlyLeaver: 'Người về sớm (Lý do)',
    applicant: 'Người đề nghị',
    approverChief: 'Người phê duyệt (Trưởng phòng)',
    approverDirector: 'Người phê duyệt (Giám đốc)',
    activity: 'Nội dung hoạt động',
    handover: 'Bàn giao / Truyền đạt',
    remarks: 'Ghi chú',
    staff: 'Nhân viên',
    approver: 'Người phê duyệt',
    cancelApproval: 'Hủy phê duyệt (Từ chối)',
  },
  
  // Comment/Memo
  comment: {
    placeholder: 'Nhập ghi chú',
    save: 'Lưu',
    saved: 'Đã lưu ghi chú',
  },

  absence: {
    listTitle: 'Danh sách vắng mặt',
    noAbsences: 'Không có người vắng mặt.',
    reason: 'Lý do',
    title: 'Đăng ký vắng mặt',
    period: 'Thời gian',
    detail: 'Chi tiết',
    comment: 'Ghi chú',
    send: 'Gửi',
    infection: 'Bệnh truyền nhiễm',
    othersWithComment: 'Khác (Cần nhập ghi chú)',
    required: 'Trường bắt buộc',
    deleteTitle: 'Xóa vắng mặt',
    deleteConfirm: 'Bạn có chắc chắn muốn xóa bản ghi vắng mặt này?',
    delete: 'Xóa',
  },

  records: {
    notSharedWithParents: 'Nội dung trang này không được chia sẻ với phụ huynh.',
    parentsRecordTitle: 'Ghi chép của phụ huynh',
    addRecord: '+ Thêm ghi chép',
    addRecordTitle: 'Thêm ghi chép',
    editDeleteRecord: 'Sửa/Xóa ghi chép',
    sleepTime: 'Thời gian ngủ',
    sleep: 'Ngủ',
    temperature: 'Nhiệt độ',
    breakfast: 'Bữa sáng',
    dinner: 'Bữa tối',
    milk: 'Sữa',
    defecation: 'Đại tiện',
    unknown: 'Không rõ',
    noRecord: 'Không có ghi chép',
    classSelection: 'Chọn lớp',
    defaultContent: 'Không có ghi chú đặc biệt',
    noClassAssigned: 'Chưa thiết lập lớp.',
  },

  attendance: {
    checkedIn: 'Đã đến',
    checkedOut: 'Đã về',
    absent: 'Vắng mặt',
    pickupChanged: 'Thay đổi đón/trả',
    inCharge: 'Lớp phụ trách',
    attendance: 'Điểm danh',
  },

  defecation: {
    hard: 'Cứng',
    normal: 'Bình thường',
    soft: 'Mềm',
    diarrhea: 'Lỏng (tiêu chảy)',
  },

  absenceReason: {
    fever: 'Sốt',
    personal: 'Lý do gia đình',
    infStrep: 'Nhiễm trùng liên cầu',
    infMycoplasma: 'Viêm phổi Mycoplasma',
    infHFMD: 'Bệnh tay chân miệng',
    infSlappedCheek: 'Hồng ban nhiễm (bệnh táo)',
    infStomach: 'Viêm dạ dày do virus (Noro, Rota, Adeno, v.v.)',
    infHerpangina: 'Herpangina',
    infRS: 'Nhiễm virus RS',
    infZoster: 'Zona',
    infRoseola: 'Phát ban đột xuất',
    infImpetigo: 'Lào',
    covid19: 'COVID-19',
    others: 'Khác',
  },


  form: {
    recipient: 'Người nhận',
    title: 'Tiêu đề',
    content: 'Nội dung',
    saveToDraft: 'Lưu vào bản nháp',
    saveToReadyBox: 'Lưu vào hộp sẵn sàng',
    sendNow: 'Gửi ngay',
    draftLine1: 'Bản nháp',
    draftLine2: 'Lưu',
    readyLine1: 'Hộp sẵn sàng',
    readyLine2: 'Lưu',
    sendLine1: 'Gửi',
    sendLine2: 'Ngay',
  },

  validation: {
    required: 'Trường này là bắt buộc',
    choice2: 'Vui lòng chọn 2 mục',
    counter: 'Vui lòng nhập trong vòng 20 ký tự',
    counter100: 'Vui lòng nhập trong vòng 100 ký tự',
    counter500: 'Vui lòng nhập trong vòng 500 ký tự',
    counter1000: 'Vui lòng nhập trong vòng 1000 ký tự',
    typeNumber: 'Vui lòng nhập số',
    email: 'Vui lòng nhập địa chỉ email hợp lệ',
    phoneNumber: 'Định dạng số điện thoại không hợp lệ',
    postalCode: 'Định dạng mã bưu điện không hợp lệ',
    integerThan0: 'Vui lòng nhập số nguyên lớn hơn hoặc bằng 0',
    multipleSelectRequired: 'Trường này là bắt buộc',
  },

  meal: {
    allFinished: 'Đánh dấu ăn hết',
    stapleFood: 'Món chính (cơm)',
    mainDish: 'Món chính',
    sideDish: 'Món phụ',
    soup: 'Canh',
    dessert: 'Tráng miệng',
    milk: 'Sữa',
    snack: 'Ăn nhẹ',
    status: {
      refill: 'Ăn thêm',
      finished: 'Ăn hết',
      unfinished: 'Còn ít',
      half: 'Ăn một nửa',
      little: 'Ăn ít',
      notEat: 'Không ăn',
      notServed: 'Chưa phục vụ',
    },
  },

  classDiary: {
    classDiary: 'Nhật ký lớp học',
    tabRecords: 'Ghi chép',
    tabDiary: 'Nhật ký',
    tabMeal: 'Bữa ăn',
    diary: 'Nhật ký',
    aim: 'Mục tiêu',
    activityMorning: 'Hoạt động buổi sáng',
    activityAfternoon: 'Hoạt động buổi chiều',
    evaluation: 'Đánh giá & Phản ánh',
    parentSupport: 'Hỗ trợ phụ huynh',
    applicant: 'Người đề nghị',
    cancelApplication: 'Hủy đề nghị',
    applied: 'Đã đề nghị',
    apply: 'Đề nghị',
    applicationSubmitted: 'Đã gửi đề nghị',
  },

  others: {
    nurseryDiary: 'Nhật ký trường',
    extendedCareDiary: 'Nhật ký chăm sóc kéo dài',
  },
  
  // Tab Bar Navigation
  tabBar: {
    communication: 'Liên lạc',
    record: 'Ghi chép',
    other: 'Khác',
    settings: 'Cài đặt',
  },
  
  // Date Navigation
  date: {
    previousDay: 'Ngày trước',
    nextDay: 'Ngày sau',
    previousMonth: 'Tháng trước',
    nextMonth: 'Tháng sau',
    daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    daysOfWeekFull: ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'],
  },
  
  // Filter Dialog
  filter: {
    classFilter: 'Lọc theo lớp',
    fiscalYear: 'Năm học',
    noClassesInYear: 'Không có lớp nào trong năm học này',
    clear: 'Xóa',
    apply: 'Áp dụng',
    yearFormat: 'Năm {year}',
  },

  // Temperature Modal
  temperature: {
    beforeCorrection: 'Trước khi sửa:',
    averageTemperature: 'Nhiệt độ trung bình:',
    timeLabel: 'Thời gian',
    temperatureLabel: 'Nhiệt độ',
  },

  // Milk Modal
  milk: {
    beforeCorrection: 'Trước khi sửa:',
    timeLabel: 'Thời gian',
    amountLabel: 'Lượng',
    milkTypeLabel: 'Sữa',
    unknown: 'Không rõ',
    breastMilk: 'Sữa mẹ',
    formulaMilk: 'Sữa bột',
    formulaPowderMilk: 'Sữa bột công thức',
  },

  // Sleep Modal
  sleep: {
    beforeCorrection: 'Trước khi sửa:',
    sleepLabel: 'Ngủ',
    startTime: 'Bắt đầu',
    endTime: 'Kết thúc',
    duration: 'Thời gian',
  },

  // Defecation Modal
  defecationModal: {
    beforeCorrection: 'Trước khi sửa:',
    defecationLabel: 'Đại tiện',
    timeLabel: 'Thời gian',
    stateLabel: 'Trạng thái',
  },

  memoru: {
    albumListTitle: 'Danh sách album',
    addAlbumButton: '+ Thêm album',
    tabAll: 'Tất cả',
    tabPublished: 'Đang hiển thị',
    tabUnpublished: 'Đang ẩn',
    createAlbumTitle: 'Tạo album',
    year: 'Năm học',
    class: 'Lớp',
    albumTitle: 'Tiêu đề album',
    comment: 'Ghi chú',
    publishStartLabel: 'Ngày bắt đầu hiển thị *',
    publishNow: 'Hiển thị ngay',
    publishEndLabel: 'Ngày kết thúc hiển thị',
    noLimit: 'Không giới hạn',
    createAsPrivate: 'Tạo ở chế độ ẩn',
    create: 'Tạo',
  },
  signup: {
    noNurseryFound: 'Không tìm thấy trường mầm non. Vui lòng đăng ký tài khoản giáo viên từ trang quản trị.',
    goToTop: 'Về trang chủ',
    logout: 'Đăng xuất',
  },

  aiReport: {
    title: 'Báo cáo VEVO',
    fiscalYear: 'Năm học',
    quarterLabel: 'Quý {quarter}',
    quarterShort: 'Q{quarter}',
    entry: {
      title: 'Báo cáo VEVO',
      description: 'Xem và tạo lại bản tổng hợp phát triển theo chu kỳ 3 tháng',
    },
    status: {
      published: 'Đã công khai',
      draft: 'Bản nháp',
      notGenerated: 'Chưa tạo',
    },
    languages: {
      en: 'Tiếng Anh',
      ja: 'Tiếng Nhật',
      ko: 'Tiếng Hàn',
      zh: 'Tiếng Trung',
      vi: 'Tiếng Việt',
      km: 'Tiếng Khmer',
      hi: 'Tiếng Hindi',
      ru: 'Tiếng Nga',
      bn: 'Tiếng Bengal',
      mn: 'Tiếng Mông Cổ',
      tl: 'Tiếng Tagalog',
      ms: 'Tiếng Mã Lai',
    },
    top: {
      yearLabel: 'Năm học {year}',
      totalChildren: '/ {count}',
      empty: 'Năm học này chưa có báo cáo nào được tạo. Vui lòng tạo hàng loạt từ trang web của cơ sở.',
    },
    quarter: {
      subtitle: 'Năm học {year} / Quý {quarter} ({monthsLabel})',
      classChildCount: '{count} trẻ',
      achievedItemCount: 'Số mục đạt được: {count}',
      progressRecordCount: 'Số ghi chép quá trình: {count}',
      generationCount: 'Số lần tạo: {count}',
      publishedAt: 'Ngày công khai: {date}',
      noClasses: 'Không có lớp nào trong quý này.',
    },
    detail: {
      subtitle: '{className} / {ageLabel} - Năm học {year} {monthsLabel}',
      coverageWarning: 'Báo cáo được tạo chỉ dựa trên dữ liệu của {months}.',
      coverageNone: 'không có',
      coverageMonths: 'tháng {months}',
      contentTitle: 'Nội dung báo cáo',
      charCount: '{count} ký tự',
      notGenerated: 'Chưa được tạo.',
      publish: 'Công khai',
      revertToDraft: 'Chuyển về bản nháp',
      regenerate: 'Tạo lại',
      noDataTooltip: 'Không thể tạo lại vì không có ghi chép phát triển trong giai đoạn này',
      regeneratingInProgress: 'Đang tạo lại...',
      operationLog: 'Nhật ký thao tác',
      lastGenerated: 'Lần tạo gần nhất: {date}',
      lastPublished: 'Lần công khai gần nhất: {date}',
      publishedNotice: 'Báo cáo đã công khai sẽ bị bỏ qua khi tạo lại hàng loạt từ trang web của cơ sở. Để tạo lại, hãy chuyển về bản nháp trước.',
    },
    confirm: {
      publishTitle: 'Công khai báo cáo của {name}',
      revertTitle: 'Chuyển báo cáo của {name} về bản nháp',
      publishMessage: 'Thông báo sẽ được gửi đến phụ huynh. Bạn có chắc chắn không?',
      revertMessage: 'Phụ huynh sẽ không còn nhìn thấy báo cáo này. Bạn có chắc chắn không?',
    },
    regenerateDialog: {
      title: 'Tạo lại báo cáo VEVO',
      description: 'Báo cáo của {name} sẽ được tạo lại.',
      translateNotice: 'Nội dung hiện tại sẽ được dịch sang ngôn ngữ đã chọn và ghi đè.',
      asyncNotice: 'Đây là xử lý bất đồng bộ nên có thể mất từ vài chục giây đến vài phút. Sau khi hoàn tất, trạng thái sẽ quay về bản nháp.',
      modeSimple: 'Tạo lại đơn giản',
      modeTranslate: 'Dịch',
      targetLanguage: 'Ngôn ngữ đích',
      processing: 'Đang tạo lại...',
      completed: 'Đã hoàn tất.',
      failed: 'Thất bại.',
      translate: 'Dịch',
      start: 'Bắt đầu',
    },
  },
}
